import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// COMPONENTS
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import Detailbar from './Detailbar';
import FeaturesSection from './FeaturesSection';
import AboutSection from './AboutSection';
import BlogSection from './BlogsSection';
import EssentialsSection from './EssentialSection';
import NewsLetter from './NewsLetter';
import ContactSection from './ContactSection';
import BenefitsSection from './BenefitsSection';
import Footer from './Footer';
import AmazonProductsSection from './AmazonProductCard';

// CART
import CartDrawer from '../Cart/CartDrawer';

// CONTEXT
import { useCart } from '../../Context/CartContext';

function HomeIndex() {

  const navigate = useNavigate();

  const [isCartOpen, setIsCartOpen] = useState(false);

  // CART CONTEXT
  const {
    cartItems,
    handleAddToCart,
    removeFromCart,
    updateQty,
    totalPrice,
  } = useCart();

  // CHECKOUT
  const handleCheckout = () => {

    if (cartItems.length === 0) return;

    localStorage.setItem('cart_access', 'true');

    setIsCartOpen(false);

    navigate('/PaymentIndex', {
      state: {
        items: cartItems,
      },
    });
  };

  // TOTAL COUNT
  const totalCount = cartItems.reduce(
    (acc, item) => acc + Number(item.qty),
    0
  );

  return (
    <div className="relative overflow-x-hidden bg-[#f7f7f7] min-h-screen">

      {/* NAVBAR */}
      <Navbar />

      {/* HERO */}
      <HeroSection />

      {/* ABOUT */}
      <AboutSection />

      {/* DETAIL */}
      <Detailbar />

      {/* PRODUCTS */}
      <AmazonProductsSection
        onAddToCart={(product) => {
          handleAddToCart(product);
          setIsCartOpen(true);
        }}
      />

      {/* OTHER SECTIONS */}
      <FeaturesSection />
      <BlogSection />
      <EssentialsSection />
      <BenefitsSection />
      <NewsLetter />
      <ContactSection />
      <Footer />

      {/* FLOATING CART BUTTON */}
      <button
        onClick={() => setIsCartOpen(true)}
        className="
          fixed bottom-6 right-6 z-40
          w-16 h-16 rounded-full
          bg-yellow-400 hover:bg-yellow-500
          shadow-2xl
          flex items-center justify-center
          transition-all duration-300 hover:scale-105
        "
      >

        <div className="relative">

          {/* CART ICON */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-7 h-7 text-black"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 3h1.386c.51 0 .955.343 1.087.837L5.61 7.5m0 0L7.5 15.75h9.75m-11.64-8.25h13.114c.72 0 1.258.675 1.102 1.378l-1.2 5.5a1.125 1.125 0 01-1.102.872H7.5m0 0L5.61 7.5m1.89 8.25a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm10.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
            />
          </svg>

          {/* BADGE */}
          {totalCount > 0 && (
            <span
              className="
                absolute -top-2 -right-3
                bg-red-500 text-white
                text-xs font-bold
                min-w-[22px] h-[22px]
                rounded-full
                flex items-center justify-center
                px-1
              "
            >
              {totalCount}
            </span>
          )}

        </div>

      </button>

      {/* CART DRAWER */}
      <CartDrawer
        isOpen={isCartOpen}
        setIsOpen={setIsCartOpen}
        cartItems={cartItems}
        removeFromCart={removeFromCart}
        updateQty={updateQty}
        handleCheckout={handleCheckout}
        totalPrice={totalPrice}
      />

    </div>
  );
}

export default HomeIndex;